import i18n from '@/shared/i18n';
import type { ConfirmOptions } from './ConfirmProvider';

type ConfirmFn = (options: ConfirmOptions) => Promise<boolean>;

export interface AttemptFormDialogCloseParams {
  busy: boolean;
  isDirty: boolean;
  confirm: ConfirmFn;
  onClose: () => void;
  messages?: Partial<ConfirmOptions>;
}

/** Dirty-close guard for overlay forms — uses common:unsavedChanges + useConfirm. */
export async function attemptFormDialogClose({
  busy,
  isDirty,
  confirm,
  onClose,
  messages,
}: AttemptFormDialogCloseParams): Promise<void> {
  if (busy) return;

  if (isDirty) {
    const discard = await confirm({
      title: i18n.t('common:unsavedChanges.title'),
      message: i18n.t('common:unsavedChanges.body'),
      cancelLabel: i18n.t('common:unsavedChanges.stay'),
      confirmLabel: i18n.t('common:unsavedChanges.leave'),
      destructive: true,
      ...messages,
    });
    if (!discard) return;
  }

  // Let the confirm click finish before the form dialog underneath handles it.
  setTimeout(onClose, 0);
}
